<template>
  <input text-input :type="type === 'repeat' ? 'password' : type" v-model="t0" :title="notice" @input="change" :class="{error}" @keyup.enter="$emit('enter')">
</template>
<script>
import _ from 'lodash';

export default{
  name: 'TextInput',
  props: {
    value: { default: '' },
    mandatory: { type: Boolean, default: false },
    number: { type: Boolean, default: false },
    digit: { type: Boolean, default: false },
    authCode: { type: Boolean, default: false },
    email: { type: Boolean, default: false },
    loginId: { type: Boolean, default: false },
    validation: { type: Function, default: null },
    type: { type: String, default: 'text' },
    title: { type: String, default: null },
    target: { type: String, default: 'pwd' },
  },
  data() {
    return {
      t0: '',
      val: this.fillCheck,
      defaultNotice: null,
    };
  },
  watch: {
    value: 'update',
  },
  mounted() {
    if (this.$props.digit) {
      this.val = this.digitCheck;
      this.defaultNotice = '숫자만 입력해주세요';
    } else if (this.$props.number) {
      this.val = this.numberCheck;
      this.defaultNotice = '숫자만 입력해주세요';
    } else if (this.$props.authCode) {
      this.val = this.authCodeCheck;
      this.defaultNotice = '인증번호를 확인해주세요';
    } else if (this.$props.email) {
      this.val = this.emailCheck;
      this.defaultNotice = '유효한 이메일을 입력해주세요';
    } else if (this.$props.loginId) {
      this.val = this.loginIdCheck;
      this.defaultNotice = 'ID 형식이 잘못되었습니다';
    } else if (this.$props.type === 'password') {
      this.val = this.passwordCheck;
      this.defaultNotice = '비밀번호는 영문, 숫자, 특수문자(_-!@#$%^&*) 조합 6~15자 입력해주세요';
    } else if (this.$props.type === 'repeat') {
      this.val = this.repeatCheck;
      this.defaultNotice = '비밀번호가 일치하지 않습니다.';
    }
    else this.val = this.$props.validation || this.fillCheck;

    this.update();
  },
  computed: {
    error() {
      return (this.$props.mandatory || _.trim(this.t0) !== '') && !this.valid;
    },
    valid() {
      return this.val(this.t0);
    },
    notice() {
      return this.$props.title || this.defaultNotice;
    },
  },
  methods: {
    passwordCheck(v) {
      return /^[\w(_\-!@#$%^&*)]{6,15}$/.test(v) && /[(_\-!@#$%^&*)]+/.test(v);
    },
    numberCheck(v) {
      return /^\d[\d]*\.?[\d]*$/i.test(v);
    },
    digitCheck(v) {
      return /^\d+$/i.test(v);
    },
    authCodeCheck(v) {
      return /^\d{6}$/i.test(v);
    },
    loginIdCheck(v) {
      return /^\w{6,16}$/i.test(v);
    },
    emailCheck(v) {
      return /^\w[-_.\w]*@\w[-_.\w]*\.[a-z]{2,5}$/i.test(v);
    },
    repeatCheck(v) {
      return _.reduce(this.$props.target.split('.'), (o, i) => o[i], this.$parent) === v;
    },
    fillCheck(v) {
      return _.trim(v) !== '';
    },
    update() {
      this.t0 = this.$props.number && !this.$props.value ? '' : this.$props.value;
    },
    change() {
      if (this.$props.digit || this.$props.authCode) {
        this.t0 = this.t0.replace(/[^\d]/gi, '');
      }
      this.$emit('input', this.$props.number ? +this.t0 : this.t0);
    },
  },
};
</script>
<style lang="less">
  @import "../../less/proj";

  .requested [text-input].error {
    .-a(@c-red) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/TextInput.vue